export const ACTIONS:any = {
	PAY: `pay`,
	MARK_AS_SENT: `sent`,
	MARK_AS_VIEWED: `view`,
	DELETE: `delete`,
	EMAIL: `email`,
	WHATSAPP: `whatsapp`,
	SAVE_AS_INVOICE: `save`,
	VIEW: 'view_invoice',
	VIEW_INVOICE_TRANSACTION: 'view_invoice-transaction',
	RECORD_PAYMENT : 'record_payment',
	CONFIRM_PAYMENT : 'confirm_payment',
	SHARE_LINK: 'share_link',
	DELETE_PAYMENT: 'delete_payment',
	RESEND_PAYMENT: 'resend_payment',
	COPY_CLIPBOARD: 'copy_clipboard',
	COPY_LINK: 'copy_link',
	REJECT_PAYMENT: 'reject',
	RE_CALL: 'recall',
	UPDATE_STATUS: 'update_status',
	ACCEPT_PAYMENT: 'accept',
	REFUND_PAYMENT: 'refund_payment',
	REFUND_ONLINE_PAYMENT: 'refund_online_payment',
	PDF_INVOICE: 'pdf_invoice',
	XML_INVOICE: 'xml_invoice',
	PUSH_FATOORA: 'push_to_fatoora',
	VALIDATE_ZATCA_INVOICE: 'validate_zatca_invoice',
	CANCEL: 'cancel_invoice'
}

export const PAYMENT_TYPES = [
	{ value:'cash', label: $localize`:@@payment_type.cash:Cash` },
	{ value:'bank-transfer', label: $localize`:@@payment_type.bank_transfer:Bank Transfer` },
	{ value:'cheque', label: $localize`:@@payment_type.cheque:Cheque` },
	{ value:'credit-card', label: $localize`:@@payment_type.credit_card:Credit Card` },
	{ value:'point-of-sale', label: $localize`:@@payment_type.point_of_sale:Point of sale(POS)` },
	{ value:'other', label: $localize`:@@payment_type.other:Other` },
];

export const TAX_TYPES = [
  { name: $localize`:@@ts.common.exclusive_of_tax:Exclusive of Tax`, id: '1' },
  { name: $localize`:@@ts.common.inclusive_of_tax:Inclusive of Tax`, id: '2' },
  { name: $localize`:@@ts.common.not_applicable:Not Applicable`, id: '3' },
]

export const ONLINE_PAYMENT_LIMIT:number = 20000;
